<template>
  <figure
    :id="anchorId"
    :class="$b()"
  >
    <span
      :class="$b('img-wrapper')"
      :style="{ aspectRatio }"
    >
      <iframe
        :class="$b('video')"
        width="100%"
        height="100%"
        :src="src"
        frameborder="0"
        allow="autoplay; encrypted-media"
        allowfullscreen=""
      />
    </span>
    <figcaption
      v-if="caption"
      :class="[$b('caption'), 't-body-sm']"
    >
      {{ caption }}
    </figcaption>
  </figure>
</template>

<script>
export default {
  name: 'ArticleVideo',

  props: {
    video: {
      type: Object,
      required: true,
    },

    caption: {
      type: String,
      default: null,
    },

    scrollToId: {
      type: String,
      default: null,
    },
  },

  computed: {
    src() {
      if (this.video.provider === 'youtube')
        return `https://www.youtube.com/embed/${this.video.providerUid}?rel=0&enablejsapi=1&origin=https://www.sungod.co`

      if (this.video.provider === 'vimeo')
        return `https://player.vimeo.com/video/${this.video.providerUid}`

      throw new Error(`Unknown video provider: ${this.video.provider}`)
    },
    aspectRatio() {
      return `${this.video.width}/${this.video.height}`
    },
    anchorId() {
      return this.scrollToId
        ? this.scrollToId.replace(/[^a-zA-Z0-9-]/g, '-')
        : null
    },
  },
}
</script>

<style lang="postcss">
.ArticleVideo {
  @apply mx-0;
}

.ArticleVideo__img-wrapper {
  @apply relative
    block
    overflow-hidden
    mb-5;

  &:before {
    display: block;
    content: '';
    width: 100%;
    padding-top: calc((9 / 16) * 100%);
  }

  > .ArticleVideo__video {
    @apply absolute inset-0;
  }

  @screen sm {
    @apply mb-sm;
  }
}

.ArticleVideo__video {
  @apply absolute
    h-full w-full
    object-cover object-left-top
    rounded-[10px];
}

.ArticleVideo__caption {
  max-width: calc(416 / 13 * 1em);
}
</style>
